import { render, staticRenderFns } from "./IconContactMatch.vue?vue&type=template&id=a9c6eaa0"
import script from "./IconContactMatch.vue?vue&type=script&lang=js"
export * from "./IconContactMatch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports